var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReady({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1268_2644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 12C13.0742 12 14.129 12.2309 15.0539 12.6684C15.4717 12.8661 15.8561 13.1027 16.1997 13.3721C16.6167 13.6992 16.9737 14.0746 17.2575 14.4876C17.7751 15.2409 18.0304 16.0916 17.9967 16.9508C17.9629 17.81 17.6414 18.6462 17.0656 19.372C16.4898 20.0978 15.681 20.6866 14.7236 21.0768C13.7662 21.4671 12.6953 21.6445 11.6229 21.5905C10.5505 21.5366 9.51587 21.2532 8.62714 20.77C7.73841 20.2868 7.02819 19.6216 6.57068 18.8437",
    stroke: "#426BA6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40002 12H21.6",
    stroke: "#426BA6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.429 5.15616C16.9714 4.37835 16.2612 3.7131 15.3725 3.22992C14.4838 2.74673 13.4492 2.46335 12.3767 2.40938C11.3043 2.3554 10.2335 2.53281 9.27606 2.92307C8.31864 3.31334 7.5098 3.90213 6.93403 4.62794C6.35827 5.35374 6.03671 6.18993 6.00296 7.04913C5.99307 7.30086 6.00799 7.55187 6.04706 7.7999",
    stroke: "#426BA6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 23.8,
    height: 23.8,
    rx: 1.9,
    stroke: "#88A5CF",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1268_2644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/ready.8212d0a152dca82571766b5d739fd771.svg";
export { ForwardRef as ReactComponent };